const isProduction = process.env.NODE_ENV === 'production'
// const isProduction = true
const isBrowser = typeof window !== 'undefined'
export function useHubspot () {
  const identify = (data, path) => {
    if (!isProduction || !isBrowser) {
      return
    }
    const _hsq = window._hsq = window._hsq || []
    _hsq.push(['identify', data])
    _hsq.push(['setPath', path])
    _hsq.push(['trackPageView'])
  }
  return {
    identify
  }
}
